import React from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';

type LocalizationProviderWrapperProps = {
    children: React.ReactNode;
};

export const LocalizationProviderWrapper = ({ children }: LocalizationProviderWrapperProps) => {
    const browserLocale = navigator.language || 'en';

    moment.locale(browserLocale);

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={browserLocale}>
            {children}
        </LocalizationProvider>
    );
};
